<template>
<div>
    <accounting-books-receipt-form :subsidiaryLedgerId="subsidiaryLedgerId" ref="accountingBooksReceiptFormModal"></accounting-books-receipt-form>
    <div class="custom-search">
        <b-row>
            <b-col class="col-md-2 mb-1">
                <validation-provider #default="{ errors }" :name="$t('accountingELedgerReport.month')" :rules="{ excluded: 0 }">
                    <label for="accounting-e-ledger-report-month-input">{{ $t('accountingELedgerReport.month') }}</label>
                    <b-form-select v-model="monthSelect" value-field="id" text-field="name" size="sm" :options="monthOption" @change="getAccountingELedgerReportList()"/>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                        {{ errors[0] }}
                    </b-form-invalid-feedback>
                </validation-provider>
            </b-col>
            <b-col class="col-md-10 custom-search d-flex justify-content-end">
                <div class="d-flex align-items-center">
                    <b-button class="d-inline-block mr-05" size="sm" variant="outline-primary" v-on:keyup.enter="getAccountingELedgerReportList()" @click="getAccountingELedgerReportList()">{{ $t('others.list') }}</b-button>
                    <b-button class="d-inline-block mr-05" size="sm" variant="outline-primary" v-on:keyup.enter="createCsvFile()" @click="createCsvFile()">{{ $t('accountingELedgerReport.create_csv_file') }}</b-button>
                </div>
            </b-col>
        </b-row>
    </div>
    <!-- table -->
    <vue-good-table ref="accountingELedgerReportList" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
            enabled: true,
            externalQuery: searchTerm
          }" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true,
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true,
            selectAllByGroup: true,
          }" :pagination-options="{
            enabled: true,
            perPage: pageLength
          }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field ==='sequenceNo'" class="text-nowrap">
                {{ $t('accountingELedgerReport.sequence_no') }}
            </span>
            <span v-else-if="props.column.field === 'accountingNumber'" class="text-nowrap">
                {{ $t('accountingELedgerReport.accounting_no') }}
            </span>
            <span v-else-if="props.column.field ==='parentAccountingNumber'" class="text-nowrap">
                {{ $t('accountingELedgerReport.parent_accounting_no') }}
            </span>
            <span v-else-if="props.column.field ==='documentDate'" class="text-nowrap">
                {{ $t('accountingELedgerReport.document_date') }}
            </span>
            <span v-else-if="props.column.field === 'accountingTransactionDocumentType'" class="text-nowrap">
                {{ $t('accountingELedgerReport.accounting_transaction_document_type') }}
            </span>
            <span v-else-if="props.column.field ==='accountingTransactionDescription'" class="text-nowrap">
                {{ $t('accountingELedgerReport.transaction_description') }}
            </span>
            <span v-else-if="props.column.field ==='amount'" class="text-nowrap">
                {{ $t('accountingELedgerReport.amount') }}
            </span>
            <span v-else-if="props.column.field ==='employee'" class="text-nowrap">
                {{ $t('accountingELedgerReport.employee') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.accountingTransactionId)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                </span>
            </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select v-model="pageLength" :options="['10','50','100', '1000']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getAccountingELedgerReportList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            pageLength: 10,
            searchTerm: '',
            dir: false,
            pageNo: 1,
            name: '',
            rows: [],
            columns: [
                {
                    label: this.$t('accountingELedgerReport.sequence_no'),
                    field: `sequenceNo`,
                },{
                    label: this.$t('accountingELedgerReport.accounting_no'),
                    field: `accountingNumber`,
                },
                {
                    label: this.$t('accountingELedgerReport.accounting_no'),
                    field: `parentAccountingNumber`,
                },
                {
                    label: this.$t('accountingELedgerReport.document_date'),
                    field: `documentDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('accountingELedgerReport.accounting_transaction_document_type'),
                    field: `accountingTransactionDocumentType`,
                },
                {
                    label: this.$t('accountingELedgerReport.transaction_description'),
                    field: `accountingTransactionDescription`,
                },

                {
                    label: this.$t('accountingELedgerReport.amount'),
                    field: `amount`,
                    formatFn: this.$formatAmount
                },
                {
                    label: this.$t('accountingELedgerReport.employee'),
                    field: `employee`,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            accountingELedgerReportList: [],
            maxSequenceNo: 0,
            date: null,
            assignCheck: true,
            tokenEmployeeId: 0,
            monthOption: [],
            monthSelect: 0,
            total: 0,
        }

    },
    props: {
        subsidiaryLedgerId: {
            type: Number
        }
    },
    mounted() {
        this.getAccountingELedgerReportList()
    },
    methods: {
        getAccountingELedgerReportList() {
            this.rows = []
            const controller = {
                name: 'AccountingTransaction',
                actionName: 'GetAccountingELedgerReport'
            }
            const data = {
                month: this.monthSelect,
                subsidiaryLedgerId: this.subsidiaryLedgerId,
                pageLength: this.pageLength,
                pageNo: this.pageNo
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.accountingELedgerReportList = []
                    this.monthOption = response.data.monthList
                    this.monthOption.splice(0, 0, this.$nullSelected())
                    this.total = response.data.total
                    response.data.accountingELedgerReportList.forEach(element => {
                        this.rows.push(element)
                    })                    
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async getInfo(id) {
            this.$refs.accountingBooksReceiptFormModal.showInfo(id)
        },
        createCsvFile() {
            const controller = {
                name: 'AccountingTransaction',
                actionName: 'CreateELedgerCsvFile'
            }
            const data = {
                month: this.monthSelect,
                subsidiaryLedgerId: this.subsidiaryLedgerId,

            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(response.data.fileName, response.data.base64File, 'csv')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
            loader.hide()
        },
        exportExcel() {
            const controller = {
                name: 'AccountingTransaction',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                dataList: this.rows,
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("E-Defter Raporu", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
